import styled from 'styled-components';

export const LoginFailedModalContainer = styled.div`
    padding: 20px 40px;
    text-align: center;
    font-size: 18px;
    border: 1px solid ${props => props.theme.black};

    svg {
        margin-bottom: 10px;
    }

    .content {
        margin: 30px 0;
    }

    @media screen and (max-width: ${props => props.theme.mobile}) {
        height: auto;
        padding: 20px;
        max-height: 450px;
        overflow: auto;

        .content {
            margin: 30px 0;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/authentication/login/LoginFailedModalStyle.js